import AssignmentIcon from "@mui/icons-material/Assignment";
import { CURRICULA, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListSpecializationsCurricula from "./List";
import CreateSpecializationsCurricula from "./Create";
import ShowSpecializationsCurricula from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <AssignmentIcon />,
  name: SpecialistServicePath + CURRICULA,
  title: "Учебни планове",
  list: <ListSpecializationsCurricula />,
  show: <ShowSpecializationsCurricula />,
  create: <CreateSpecializationsCurricula />,
  permission: permissions.canPreviewSpecializationsCurricula,
  showPermission: permissions.canPreviewSpecializationsCurricula,
  createPermission: permissions.canManageSpecializationsCurricula,
};
